export default {
  msg: {
    //countdown / time
    seconds: `Segundos`,
    minutes: `Minutos`,
    hours: `Horas`,
    days: `Días`,

    //titles / sub
    insights: "Informaciones",
    fund_holdings: "Valores",
    charity: "Caridad",
    charity_sub: "Stratum ha donado lo siguiente a organizaciones benéficas.",
    network_distributions: "Distribuciones de red",
    network_distributions_sub: "Monedas ganadas en distribuciones de red.",
    redemption_sub: `Operation to liquidate BLUE, and receive the equivalent value in dollar-pegged stablecoin Tether (USDT).`,
    twofa_info: "Para redimir, debe habilitar 2FA.",
    redemption_sub_one:
      "Redenciones están disponibles los miércoles, de 0h a 17h (UTC -3), y tardarán 3 días hábiles en abonarse (D+3).",
    redemption_sub_two:
      "Una opción de pago el mismo día está disponible por una tarifa.",
    redemption_sub_three: "Redenciones se pagan mediante la red Tron (TRC-20).",

    //a
    alert_created_deposit:
      "Su dirección ya ha sido creada, actualice la página.",
    alert: "Alerta",
    asset_allocation: "Asignación de criptomonedas",
    amount_below_purchase_limit: "Cantidad por debajo del mínimo de compra",
    amount_below_minimum_trade_limit:
      "Cantidad por debajo del mínimo intercambio",
    activating_account: "Por favor esperar. Activando cuenta...",
    activation_successful:
      "Felicitaciones, su cuenta ahora está activa. Puede iniciar sesión ahora.",
    activation_successful_2fa:
      "Felicitaciones, su código 2fa ahora está activo. Puede proceder a los servicios.",
    activation_link_invalid: "El enlace de activación no es válido.",
    apply_filter: "Aplicar filtro",
    add_funds: "Añadir BLUE",
    address: "Dirección",
    actions: "Acciones",
    action: "Acción",
    all: "Todo",
    all_rights_reserved: "Todos los derechos reservados",
    all_transactions: "Todas las transacciones",
    already_member: "¿Ya eres usuario?",
    amount: "Cantidad",
    approx_value: "Valor aproximado",
    equivalent_in: `Equivalente en`,
    one_blu_equals: `1 BLUE iguala`,
    equivalence: "Equivalencia",
    one_blu: "1 BLUE",
    updated_last: "Última actualización",
    all_time: "Tiempo total",
    activate: "Activar",
    available_info: "Disponible para redención",
    available_to_redeem: "Debido a la gran demanda de redenciones, y la cantidad actual de fondos bloqueados en exchanges, esta redención superará nuestro umbral de liquidez de redención factible para esta semana. Intente con un monto más bajo, o intente su redención nuevamente la próxima semana.",
    available: "Disponible",
    attention_done: "Atención: su pedido se ha realizado",
    attention_cancel:
      "Atención: su pedido ha sido cancelado. Si desea comprar BLUE, abra un nuevo pedido",
    attention_waiting_hours:
      "Atención: ¡Su orden de compra vencerá en {horas}! Pasado este tiempo, su pedido se cancelará automáticamente.",
    attention_waiting_days:
      "Atención: Su pedido tiene {hours} hasta el vencimiento.",
    attention_waiting_hours:
      "Atención: Su pedido tiene {hours} hasta el vencimiento.",
    attention: "Atención",
    available_balance: "Saldo disponible: ",
    allocation: "Asignación",
    authenticate: "Autenticar",
    address_empty: "La dirección está vacía",
    average_time: "Depósitos pueden tardar hasta 5 minutos.",

    //b
    balance: "Balance | Balances",
    begins: "Comienza",
    bonus: "Bonus",
    buy: "Comprar",
    buy_tokens: "Comprar BLUE",
    buyer_bonus: "Bonus de compra",
    blank: "",
    bonus_0dot5: "Bonus(0.5%)",
    bonus_1: "Bonus(1%)",
    bonus: "Bonus",
    buy_here: "Compre Aquí",
    buy_now: "Compre Ahora",
    bktc: "BKTC",
    back: "Previo",
    balance_equivalence: "Balance equivalente en",
    blue_team: "Equipo BLUE",
    buy_pix: "Comprar BLUE via PIX",
    buy_pix_info:
      "Utilizando SWAPiX, un socio de confianza que ofrece intercambios de fiat a cripto.",
    blue_club_status: "Blue Club status",

    balance_text_tusd: "TrueUSD Stablecoin al par con el Dólar Americano",
    balance_text_btc: "Bitcoin",
    balance_text_rlt: "RAS Stablecoin al par con el Real Brasileño",
    balance_text_eth: "Ethereum",
    buy_token: "COMPRAR TOKEN",
    boleto: "Boleto",
    best_way_buy: "Mejor manera de comprar",
    browser_message:
      "Si no puede ver el document, por favor use Firefox o Safari.",
    business_day: "DÍAS HÁBILES",
    no_additional_fee: "Sin cargos adicionales.",
    rush_today: "RUSH (hoy)",
    receive_today_info: "Recibirás en el mismo día natural.",
    basket_value: "Valor de la cesta",

    //c
    charity: `Caridad`,
    clear_filter: "Limpiar filtro",
    cancelled: "Cancelado",
    cancel_purchase: `Cancelar Compra`,
    click_on_transaction_to_get_details: `Haga clic en una transacción para más detalles.`,
    chart: "Gráfico",
    crypto: "Cripto",
    copy_twofa:
      "Escanee el código QR con su teléfono celular usando Google Authenticator o Authy, o escriba el código. <strong> Mantenga este código en un lugar seguro en caso de que pierda su teléfono, y no lo comparta con nadie. Puede recuperar su 2FA usando este código.</strong>",
    confirm_delet: "¿Estás seguro?",
    click_here: "Acceder SmartWallet",
    confirm_redeem: "Su redención está siendo procesado.",
    confirm_withdraw: "Su retiro está siendo procesado.",
    amount_revice_withdraw: "Cantidad a recibir",
    amount_revice_withdraw_fee: "Tarifa: ",
    can_not_load_data: "No se pueden cargar datos.",
    change: "Cambiar",
    coin_slider_BTC: "Bitcoin",
    coin_slider_RAS: "Ras - Stablecoin al par con el Real Brasileño",
    coin_slider_BLU: "TrueUSD - Stablecoin al par con el Dólar Americano",
    coin_slider_ETH: "Ethereum",
    coin_slider_ZAR: "RAND - Moneda de Sudáfrica",
    coin_slider_EUR: "Euro - Moneda de la Unión Europea",
    coin_slider_GBP: "Libra Esterlina - Moneda del Reino Unido",
    coin_slider_CHF: "Franco Suizo - Moneda de Suiza",
    coin_slider_CAD: "CA$ - Moneda de Canada",
    coin_slider_AUD: "A$ - Moneda de Autralia",
    coin_slider_CNY: "Yuan - Moneda China",
    coin_slider_HKD: "HK$ - Moneda de Honk Kong",
    coin_slider_USDT: "USDT - Stablecoin al par con el Dólar Americano",
    cancel: "Cancelar",
    contact_us_any_question:
      "No dude en contactarnos en support@bluetoken.io si tiene alguna pregunta.",
    cellphone: "Celular",
    cpf: "CPF",
    cep: "CEP",
    complement: "Complemento",
    city: "Ciudad",
    criptocurrency: "Criptomoneda",
    chose_two_coins:
      "Rentabilidad mostrada acumulada este año, hasta 23 de Diciembre de 2022",
    click_here_to_vote: "Haga clic aquí para votar",
    copy_address: "Copiar dirección",
    create_order: "Criar novo pedido",
    cancel_transaction: "Cancelar transacción",
    canceling_order: "Pedido cancelado",
    canceling: "Cancelado",
    checking_open_orders: "Comprobación de pedidos abiertos",
    copy_alert_info_otc: "Copiado: cantidad esperada y cantidad estimada",
    confirm_recaptcha: "Confirme o CAPTCHA",
    create_deposit_address: "Crear dirección de depósito",
    check_info_redeem: "He verificado que la información anterior es precisa.",
    current_value: "Valor Actual",
    component_hold: "Componente",
    current_weight: "Peso actual",
    currently_generating: "Actualmente generando recompensas diarias",
    country_residency: "País de residencia",
    countries_not_allowed:
      "USA/China/HK - ¡Países que no pueden usar nuestros servicios!",
    clain_your_nft: "Obtenga su NFT",

    //check
    check_your_email:
      "Por favor revise su correo electrónico y siga las instrucciones.",
    check_your_email_for_userid:
      "Recibirá un correo electrónico con su ID de usuario.",
    check_your_email_for_recovery_link:
      "Recibirá un correo electrónico con un enlace de recuperación.",
    check_your_email_for_pin:
      "Recibirá un correo electrónico con el PIN para confirmar la transacción",
    check_your_email_for_pin_redeem:
      "Recibirá un correo electrónico con el PIN para confirmar la transacción",
    if_no_email_spam: `Si no puede encontrar el correo electrónico, revise su casilla de spam.`,
    closes: "Cierra",
    component: "Componente | Componentes",
    confirm: "Confirmar",
    confirm_operation: "Confirmar Operación",
    confirmation_pin: "Confirmar Su Pin",
    confirmation_pin_email_hint:
      "A continuación, recibirá un correo electrónico con un pin de confirmación, requerido para completar su operación.",
    contact: "Contacto",
    continue: "Continuar",
    copied: "Copiar",
    copy: "Copiar",
    currency: "Moneda",
    click_here_action: "haga click aquí",
    change_withdraw_partner: "Para cambiar de socio de retiro,",

    //d
    denied: "Negada",
    dashboard: "Panel Principal",
    dont_have_btc: `¿No tiene Bitcoin?`,
    details: "Detalles",
    deposits: "Depósitos",
    deposit_amount: "Cantidad del Depósito",
    dear_blu_holder: "Estimado titular de BLUE",
    district: "Distrito",
    donwload: "Descargar",
    documentation_info: "Hojas de datos, métodos, cálculos y otros documentos",
    dropdown_header_withdraw: "Envíe sus tokens a una billetera externa",
    dropdown_header_deposit: "Reciba sus tokens de una billetera externa",
    dropdown_header_redeem: "Intercambie sus tokens",
    dropdown_header_internal: "Envíe BLUE a otro usuario",
    destination_user: "Usuario de destino",
    deposit_received: "Su depósito ha sido recibido",
    do_you_want: "¿Quieres cancelar de todos modos?",
    download_pdf: "Descargar PDF",
    deposit_sub:
      "El depósito es una operación que le permite recibir {coin} de una billetera externa.",
    delivery_speed: "Velocidad de entrega",
    download_csv: "Descargar CSV",

    //dates
    date_1: "4 de diciembre de 2018",
    date_2: "15 de enero de 2019",
    date_3: "16 de enero de 2019",
    date_4: "15 de febrero de 2019",
    date_5: "16 de febrero de 2019",
    date_6: "6 de abril de 2019",
    date_7: "11 de abril de 2019",

    days_remaining: "Días restantes",
    deposit: "Depósito",
    disclaimer: "Renuncia",
    documentation: "Documentación",

    //e
    expire_in: "Caducar a las",
    expired: "Expirado",
    earn_on_referrals: "Gane en referencias",
    earn_bonus_tooltip: "Bonificación obtenida del programa de referencia.",
    email: "Email",
    equals: "Igual a",
    expired: "Expirado",
    export_csv: "Exportar CSV",
    ends: "Termina",
    explorer: "Explorador",
    equivalent: "Equivalente",
    equivalent_to: "Equivalente a",
    expired_pin: "Pin expirado",
    enable_2fa: "Habilitar 2FA",
    eth_contract_message: "No envíe Ether mediante un Smart Contract",
    clicl_expand: "Clic para ampliar",
    expand_chart: "Expandir gráfico",
    estimated_info_modal_equivalent:
      "Valor estimado basado en el intercambio de Tether con otras monedas",

    //error_message
    error: "Error",
    error_create_address: "Error al crear la dirección, inténtalo más tarde",
    error_redeem: "Hubo un error con su solicitud.",
    error_redeem_amount:
      "Asegúrese de tener suficiente balance disponible y que la cantidad solicitada esté por encima del mínimo.",
    error_redeem_amount_no_funds:
      "No tiene suficientes fondos desbloqueados para realizar esta operación.",
    error_redeem_amount_below_min:
      "El monto DEBE estar por encima del mínimo requerido.",
    error_redeem_address: "Asegúrese de usar una dirección BTC válida.",
    error_withdraw_address: "Asegúrese de usar una dirección BLUE válida.",
    error_redeem_confirm: "Se produjo un error, verifique los campos.",
    error_internal_member_not_found: "ID de usuario no encontrado",
    error_pool_avatar: "Avatar ya existe.",
    error_pool_avatar_select: "Debe elegir un nombre de avatar y un icono.",

    //f
    faq: "Preguntas Frecuentes",
    fee: "Tarifa | Tarifas",
    fees_minimums: "Tarifas & Mínimos",
    forgot_password: "Recuperar contraseña",
    forgot_userid: "Recuperar User ID",

    fees_minimum_amount:
      "La tarifa es del 2 USDT del monto, con un mínimo de 2 USDT",
    fee_1dot5: "Tarifa 1.5%",
    fee_2dot5: "Tarifa 2.5%",
    fee_4: "Tarifa 4%",
    fee_6: "Tarifa 6%",
    failed: "falló",
    fund_in_maintenance:
      "Nuestro sistema se encuentra actualmente en mantenimiento, intente su operación más adelante.",
    fill_form_boleto: "Rellene el formulario para generar un boleto",
    fill_form: "Completa el formulario",
    fact_sheet: "Hoja Informativa",
    finish_Vote: "Finalizar votación",
    form_error_fields: "Todos los campos son obligatorios!",
    found_member: "Miembro encontrado",
    fee_info_redeem_one: "La tarifa es",
    fee_info_redeem_two: "de monto, con un mínimo de",
    fee_redeem_wave_info:
      "La tarifa es de 2 USDT para redenciones por debajo de 50 USDT.",
    error_xgateway:
      "Nuestra red actualmente está experimentando problemas con la cripto seleccionada. Vuelva a intentar en unos minutos.",

    //g
    get_pin: "Recibir pin",
    global_search: "Búsqueda global",
    generate_slips: "Generar Boleto",
    g_l: "G/P",
    generating_tokens: "Generando tokens, por favor espere",

    //h
    help: "Soporte",
    history: "Historia",
    hypothetical_portfolio: `Cesta hipotética sujeta a cambios.`,
    home: "Inicio",
    here: "aquí",
    how_vote: "¿Cómo votar?",
    header_referral: "¿Alguien te refirió?",
    how_it_works:
      "<a href=https://youtu.be/NujOX3n7d-g target=_blank>¿Como funciona?</a>",

    //i
    input_usdt_address: "Ingresar dirección de USDT",
    input_blue_amount: "Ingrese la cantidad de BLUE",
    input_amount_redeem: "Ingrese la cantidad de BLUE que desea redimir.",
    input_amount_withdraw: "Ingrese la cantidad de BLUE que desea retirar.",
    input_amount_transfer:
      "Ingrese la cantidad de BLUE que desea transferir a otra cuenta",
    info_redeem_step_3: "Para su seguridad, ingrese el PIN y 2fa.",
    info_redeem_address_step_4: "Dirección: ",
    info_redeem_email_step_4:
      "Recibirá todos los detalles en su correo electrónico.",
    info_redeem_step_4: "El proceso se completará hoy.",
    info_redeem_step_5: "El proceso demorará 3 días hábiles.",
    info_withdraw_step_4: "Epere hasta que blockchain procese su transacción.",
    info_2fa_tip:
      "Como medida de segurança, você deve primeiro habilitar o 2FA para transferir ou resgatar seus tokens.",
    inform_the_amount_bitcoin_address:
      "Informar el monto y su dirección Bitcoin",
    inform_the_amount_blu_tag: "Informar la cantidad y BLUE Dirección",
    inform_the_amount_user_id: "Informar el monto de BLUE y el ID del usuario",
    internal_transfer: "Transferencia interna",
    internal: "Transferencia interna",
    internal_sub:
      "Transferencia Interna es una operación que le permite enviar BLUE a otro usuario dentro de la plataforma Blue.",
    internal_steps: "Pasos de transferencia interna",
    internal_action_send: "Enviado",
    internal_action_receive: "Recibido",
    info_usdt_blue_purchase:
      "Envíe solo USDT a esta dirección. Debe utilizar la red Tron (TRC20).",
    input_valid_usdt: "Ingrese una dirección Tether (USDT) TRC20 válida",
    send_to_my_usdt: "Enviar a mi billetera Tether",
    usdt_info_trc20:
      "Usamos la red TRC20 de Tron. Asegúrese de ingresar solo una dirección TRC20.",
    input_text_USDT: "Ingrese la cantidad y la dirección USDT",
    input_text_invalid_USDT: "Ingrese la cantidad de USDT que desea retirar.",

    //insert
    insert_bitcoin_address: "Ingresar dirección de Bitcoin",
    insert_quantity: "Ingresar cantidad",
    insert_your_pin: "Ingresar pin",

    //invalid
    invalid_address: "Dirección inválida",
    invalid_amount: "Monto invalido",
    invalid_credentials: "Credenciales inválidas.",
    invalid_destination_address: "Dirección inválida",
    invalid_phone: "Teléfono inválido",
    invalid_phone_country: "País no permitido para usar nuestros servicios.",
    invalid_email: "Email inválido.",
    invalid_has_accepted_terms: "Por favor, acepte los Términos y Condiciones.",
    invalid_is_aware_token_redemption:
      "Por favor marque la casilla de verificación de arriba.",
    invalid_input_amount_crypto: "Monto invalido",
    invalid_is_not_usa_citizen:
      "Confirme que no es ciudadano o residente de los Estados Unidos.",
    invalid_is_not_china_citizen:
      "Confirme que no es ciudadano o residente de Hong Kong.",
    invalid_password: "Contraseña inválida",
    invalid_password_confirmation: "Confirmación de contraseña inválida.",
    invalid_password_old: "Contraseña actual inválida.",
    invalid_pin: "PIN inválido",
    invalid_referral_code: "Código de referencia inválido.",
    invalid_userid: "Identifición de usuario inválida.",
    invalid_user_id: "Identifición de usuario inválida.",
    invalid_connetion:
      "Hubo un problema al autenticar su solicitud, verifique su conexión o su usuario.",
    invalid_2fa_code: "Código 2fa incorrecto.",
    insert_referral_code: "Insertar código de referencia (Opcional)",
    Invalidaddress: "Esta dirección no es aceptada.",

    //l
    language: "Idioma | Idiomas",
    launch: "Lanzamiento",
    launch_april: "Lanzamiento - ABRIL 2019",
    legal: "Legal",
    list: "Lista",
    last_update: "Última Actualización",
    link_no_account: `Si aún no tiene una cuenta Stratum, <a href="https://auth.stratum.hk/signup.php?lang=en" target="_blank"> haga clic aquí </a> para crear uno.`,
    loading_balance: "Cargando el saldo de la cuenta...",
    live_price: "Precio en vivo",
    last_month_blue_total: "Blue Pool pagó un total de",

    //languages
    en: "EN | English",
    es: "ES | Spanish",
    pt: "PT | Portuguese",

    loading: "Cargando",
    loading_data: "Cargando Datos de Compra",
    load_fee: "Tarifa de Venta",
    login: "Ingresar",
    login_successful: "Sesión iniciada con éxito",
    login_here: "Ingresar Aquí",
    logout: "Salir",
    latest: "Último",

    //m
    minimum: "Mínimo",
    money: "dinero",
    masternodes: "masternodes",
    make_new_redeem: "Hacer una nueva redención",
    methodology: "Metodología",
    min_amount_is: `El monto mínimo es`,
    member_not_found: "Miembro no encontrado.",
    make_sure_address: "Asegúrese de utilizar una dirección BLUE válida.",
    my_balances: "Mis saldos",
    my_balance: "Mis saldos",
    my_total_value: "Mi saldo total",
    my_gain_loss: "Mi Ganancia/Pérdida",
    minimum_purchase_USDT:
      "El saldo mínimo requerido es de 20 USDT. Por favor aumente su saldo.",
    minting: "Creando",
    member_benefits: "Beneficios de la Membresía",
    my: "Mi",

    //n
    name: "Nombre",
    name_optional: "Nombre (Opcional)",
    next: "Próximo | Prox",
    no_data_found: "Datos no encontrados",
    no_rec_transactions_found: "No se encontraron transacciones.",
    not_enough_balance: "No hay suficiente balance",
    not_member_yet: "¿No eres miembro todavía?",
    next_step: "Próximo paso",
    number: "Número",
    network: "La red",
    notification: "Notificación",
    only_one_day: "Solo se permite 1 redención por día.",

    //o
    of: "de",
    opens: "Abre",
    open_account: "Abrir Cuenta",
    operations: "Operaciones",
    Operations: "Operaciones",
    or: "o",
    one_token_equivalence: "Un BLUE equivalente en",
    optional: "Opcional",
    otc_info:
      "Proporcione la siguiente información. Nuestro mostrador OTC se pondrá en contacto para ayudarlo con su compra.",
    otc_thank_msg:
      "Nuestro mostrador de OTC se comunicará con usted a la brevedad.",
    otc_purcahse_info: "Información de compra",
    otc_purcahse: "compra OTC",
    otc_purchase_info_to_user:
      "Nuestra mesa OTC está procesando su compra, por favor espere.",

    //p
    past_2fa: "Ingrese aquí el código 2FA con 6 dígitos",
    pin_already_been_used: "Pin ya fue usado",
    price_graph: "Gráfico de Precios",
    portfolio_value: "Valor de Cripto-cesta",
    pay_slip_info: "Pagar el boleto para recibir sus BLUE",
    purchase_information: "Informacion de compra",
    please_chose_two_coins: "Elija 2 criptomonedas.",
    phone_optional: "Celular",
    phone_code: "Código de país",
    phone: "Fone",
    purchase_success: "Su compra ha sido creada para el usuario.",
    price_history_list: "Historial de precios",
    please_verify_information:
      "Por favor verifique la siguiente información en forma precisa.",
    closing_price: "Precio de cierre",
    pay_with_USDT: "Pagar con saldo USDT",

    //password
    change_password: "Cambiar contraseña",
    current_password: "Contraseña actual",
    confirm_password: "Confirmar contraseña",
    new_password: "Nueva contraseña",
    password: "Contraseña",
    password_create: "Crear nueva contraseña",
    password_changed: "Contraseña ha sido cambiada",
    password_requirements:
      "Contraseña debe contener al menos 8 caracteres, 1 carácter especial (-_+=,<.>;:^~@#$%&*), 1 letra minúscula, 1 letra mayúscula y 1 número.",
    recover_password: "Recuperar Contraseña",
    recover_userid: "Recuperar ID de Usuario",
    password_suggestion: "Use la contraseña sugerida de Blue.",
    confirm_password_error: "Confirme su cambio de contraseña.",
    wrong_password_confirmation: "Confirmación de contraseña incorrecta",
    phone_already_registered: "Este teléfono ya está registrado.",
    email_already_registered: "Este correo electrónico ya está registrado.",

    pay_with: "Pagar con cripto",
    perc_portfolio: "% of Asignación de cripto-cesta",
    phase: "Fase | Fases",
    portfolio: "Cripto-cesta",
    price: "Precio",
    pre_sale: "Pre-Venta",
    preferences: "Preferencias",
    preferred_language: "Idioma preferido",
    previous: "Previos | Prev",
    privacy_policy: "Política de Privacidad",
    purchase: "Compra",
    performance: "Evolución de Precio",

    //q
    quantity: "Cantidad",

    //r
    receive_calculator_text: `El cálculo excluye cualquier tarifa impuesta por su propia cartera y la red. Recomendamos depositar un poco más de la cantidad deseada.`,
    receive: "Recibir",
    receiving_email: "Recibiendo email",
    recent_transactions: "Transacciones recientes",
    redeem: "Redimir",
    referral_award: "Recompensa de Referencias",
    referrals: "Referencias",
    referral_code: "Código de referencia",
    report: "Informe trimestral",
    report_link_text: "Lanzamiento",
    report_link_download_quarter:
      "Descargue el informe trimestral Octubre - Diciembre 2022 (T4 2022)",
    report_link_span:
      "Los informes se publican la primera semana de cada trimestre.",
    redemptions: "Redenciones",
    redemption: "Redención",
    redemption_info:
      "<strong>Redenciones sin cargo:</strong> Usted califica para redimir hasta <strong>50 BLUS</strong> sin tarifa. La cantidad debe valer más de <strong>1000 TUSD</strong>.",
    redeem_pin: "Ingresar PIN",
    redeem_2fa: "Ingresar 2FA",
    redeem_not_allowed_today:
      "Redenciones están disponibles Miércoles, de 00h a 17h (UTC -3).",
    redeem_not_allowed_today_1:
      "Redenciones no están disponibles hoy. Consulte el programa de redención.",
    redeem_not_allowed_today_2:
      "Redenciones están disponibles Martes, de 00h a 17h (UTC -3).",
    redeem_not_allowed_today_3:
      "Redenciones están disponibles Miércoles, de 00h a 17h (UTC -3).",
    redeem_not_allowed_today_4:
      "Redenciones están disponibles Jueves, de 00h a 17h (UTC -3).",
    redeem_not_allowed_today_5:
      "Redenciones están disponibles Viernes, de 00h a 17h (UTC -3).",
    redeem_not_allowed_today_6:
      "Redenciones están disponibles Sábado, de 00h a 17h (UTC -3).",
    redeem_not_allowed_today_7:
      "Redenciones están disponibles Domingo, de 00h a 17h (UTC -3).",
    redeem_deleted_success: "Redención cancelada con éxito!",
    redeem_deleted_error: "Algo salió mal, intente nuevamente más tarde.",
    reedeem_2fa_text: `
            <p>¿Qué es 2FA y por qué debería usarlo?</p>
            <p>2FA significa Autenticación de 2 factores. Protege su cuenta combinando algo que sabe (su contraseña) con algo que tiene (como su teléfono celular o clave de seguridad).</p>
            <p>Después de configurar 2FA en su teléfono, verá un código de acceso que cambia constantemente. Debe usar el código de acceso 2FA cada vez que redime tokens; sin embargo, solo tiene que instalar 2FA una vez.</p>
            <p>En caso de que aún no tenga un autenticador, utilice uno de los siguientes:</p>
            <a href="https://www.google.com/landing/2step/#tab=how-it-works" target="_blank">Autenticador Google</a>
            <a href=" https://authy.com/download/" target="_blank">Autenticador Authy</a>
        `,
    tutorial_tittle: `<p style="color:#424b7d">¿Cómo depositar {coin}?</p>`,
    tutorial_deposit: `
        <p>1. Crear una dirección de depósito de BLUE;</p>
        <p>2. Busque el formulario "Enviar" en la cartera externa;</p>
        <p>3. Escanee o copie la dirección del token BLUE en aquel formulario.</p><br/>
        <b>Nota:</b>
        <span>A los depósitos BLUE se les cobra una tarifa de red del 6%, pagada por el remitente. <a href="https://bluetoken.io/fees" target="_blank" style="margin-top:0px; display: contents;">Tarifa.</a></span>
    `,
    tutorial_deposit_usdt: `
    <p>1. Crear una dirección de depósito de Tether (USDT);</p>
    <p>2. Busque el formulario "Enviar" en la cartera externa;</p>
    <p>3. Escanee o copie la dirección del Tether (USDT) en aquel formulario.</p><br/>
    <b>Nota:</b>
    <span>Asegúrese de seleccionar la red Tron (TRC20).</span>
`,
    tutorial_tittle_withdraw: `<p style="color:#424b7d">Cómo agregar el Blue Token en carteras externas?</p>`,
    tutorial_withdraw: `
        <p>1. Seleccione Binance Smart Chain (BSC) en la red de cartera externa;</p>
        <p>2. Copie esta dirección de contrato de token Blue e impórtela en la cartera externa;</p>
    `,
    tutorial_withdraw_pt2: `
        <b>Note:</b>
        <p>- Blue Token no asume responsabilidad por las operaciones que ocurren en plataformas de terceros.</p>
        <p>- Todas las transacciones que se originan fuera de nuestra plataforma tienen un cargo de red del 6%. <a href="https://bluetoken.io/fees" target="_blank" style="margin-top:0px; display: contents;">Tarifa.</a></p>
    `,
    cancel_redeem: `Cancelar Redención`,
    retry: "Re-procesar",
    required_fields: "Campos requeridos",
    recipients_user_id: "ID de usuario del destinatario.",
    required_fields_amount_uid:
      "La cantidad y el UID son necesarios para esta acción.",
    redeeming: "Redimiendo",
    receiving: "Recepción",

    //referral texts
    referral: "Referencia",
    referral_text_1:
      "Cuando refieres a personas para comprar BLUE, obtienes una recompensa y ellos obtienen un bono, ¡pagado en BLUE!",
    referral_text_2:
      "Entregue el enlace o código de referencia a sus amigos y familiares. Las recompensas y bonificaciones son ilimitadas. No importa cuántas veces sus referidos compren BLUE, obtendrá una recompensa y ellos recibirán una bonificación.",
    referral_text_3:
      "Para activar su código de referencia, primero debe comprar BLUE. Una vez que compre BLUE, vuelva a esta página y comience a usar su código de referencia.",
    review_your_purchase: "Revisar Su Compra",
    reward: "Reconpensa",
    rows_per_page: "Filas por Página",
    redeemed_value: "Monto Redimido",
    staking_rewards: "Staking rewards",

    //s
    save: "Guardar",
    send: "Enviar",
    settings: "Configuraciones",
    header_settings: "Configuraciones",
    signup: "Registrarse",
    something_went_wrong: "Algo salió mal",
    subtotal: "Subtotal",
    send_to_btc_adress: "Dirección de Destino",
    send_to_blu_adress: "Dirección de Destino <strong>BLUE</strong>",
    send_to_blu_adress_on: "Dirección de Destino <strong>BLUE</strong> en",
    step_1_withdraw_blue: "1. Seleccione su billetera preferida para retirar.",
    allowed_wallets: "*Carteras permitidas:",
    step_2_withdraw_blue:
      "2. Haga clic para copiar la dirección del contrato de Blue Token en Binance Smart Chain:",
    step_3_withdraw_blue:
      '3. Haga clic para importar automáticamente el token de Blue en <a href="https://bit.ly/3wMClbk" target="_blank">Metamask</a>',
    step_3_withdraw_blue_p2:
      "siga las instrucciones para agregar manualmente el token de Blue en:",
    or: "o",
    contract_address: "0xE2F3Db52F7065220e113014f23f5DD4c7bafBAc2",
    success: "Éxito",
    success_create_wallet: "Dirección creada con éxito",
    session_expired: "Sesión expirada. Por favor inicie sesión nuevamente.",
    services: "Servicios",
    staking_APY: "Apuesta APY",
    submit: "Enviar",

    months: {
      1: "Enero",
      2: "Febrero",
      3: "Marzo",
      4: "Abril",
      5: "Mayo",
      6: "Junio",
      7: "Julio",
      8: "Agosto",
      9: "Septiembre",
      10: "Octubre",
      11: "Noviembre",
      12: "Diciembre"
    },

    //pool
    pool: "Pool",
    join_pool: "Registrese y gane",
    monthly_rewards: "Recompensas del pool de {month}",
    my_rewards: "Estimación de mis recompensas",
    qualification_status: "Estado de calificación",
    need_to_qualify: "Necesita de",
    to_qualify: "para calificar",
    calculating: "calculando...",
    posted_soon: "El Pool está siendo calculado y se publicará pronto.",
    nobody_qualified:
      "Nadie ha calificado aún para ganar las recompensas del pool. ¡Sea el primero y gane!",
    leaderboard: "Tabla de líderes",
    last_month_winners: "Ganadores del mes pasado",
    referral_volume: "Volumen de referencias",
    reward_pool: "% de Recompensa",
    estimated_pool: "Estimado",
    earned_pool: "Ganado",
    view_all: "verlo todo",

    modal_pool_title: "Recompensas del Blue Pool",
    modal_pool_text:
      "Cada mes se crea un grupo para recompensarlo por las compras de sus referidos. Los participantes que acumulan 1 token BLUE o más en compras por referencias, ganan automáticamente una parte del pool. <a href=https://youtu.be/NujOX3n7d-g target=_blank>Ver tutorial</a>",
    modal_pool_important: "Importante",
    modal_pool_text2: "Para participar, primero debe crear un avatar.",
    modal_pool_text3: "Su avatar no se puede cambiar en el futuro.",
    modal_pool_nick: "Crear un apodo",
    modal_pool_nick_span:
      "Para proteger su privacidad. Le aconsejamos que no utilice su nombre real.",
    modal_pool_avatar: "Seleccione Avatar",
    modal_pool_btn: "PARTICIPAR",

    modal_pool_welcome: "Bienvenido(a) a Blue Pool",
    modal_pool_span:
      "Cuando sus referencias acumulen 1 BLUE en las compras, su avatar se mostrará en el tabla de líderes, asegurando una participación en el pool.",
    modal_pool_span2: "¡Cuanto más compren, mayor será su participación!",
    modal_pool_referral: "Su ID de referencia:",
    modal_pool_referral_link: "Su enlace de referencia",
    modal_pool_close: "CERRAR",

    street_name: "Calle",
    state: "Estado",
    select_partner: `Seleccione un socio`,
    start_withdrawal: "Iniciar retiro",
    start_internal_transfer: "Iniciar transferencia interna",
    send_exactly: "Enviar exactamente a la siguiente dirección:",
    seller_buy:
      "Compre como el miembro que desee, solo debe proporcionar el UID y la cantidad.",
    sector: "Sector",

    //steps_text
    step_amount: "Monto",
    step_recipient: "Destinatario",
    step_verification: "Verificación",
    step_authentication: "Autenticación",

    //status
    status_new: "Nuevo",
    status_waiting: "Esperando",
    status_processing: "Procesando",
    status_done: "Completo",
    status_failed: "Fallado",
    status_cancelled: "Cancelado",
    status_denied: "Negado",
    status_expired: "Expirado",
    status_queued: "En línea",
    skip: "passar",

    //t
    tag: "tag",
    tag_important:
      "Asegúrese de establecer el tag ID correcto para que el monto se envíe a su dirección.",
    terms_and_conditions: "Términos y condiciones",
    tokens_go_on_sale: "BLUE salen a la venta",
    token_presale: "Pre-venta",
    token_distribution: "Distribución",
    total: "Total",
    total_debit: "Débito Total",
    total_received: "Total Receibido",
    total_to_pay: `Total a pagar`,
    total_to_transfer: `Total a enviar`,
    transaction: "Transacción | Transacciones",
    transaction_completed: "Transacción Completa",
    transaction_details: "Detalles de la Transacción",
    type: "Tipo",
    token: "Token",
    token_info: "Info",
    token_supply: "Suministro",
    token_nav: "NAV",
    fund_value: "Valor del Fundo",
    token_price: "Precio",
    transaction_with_wrong_status: "Transacción con status incorrecto",
    trade_not_found: "Redención no encontrada. Empezar de nuevo.",
    transfers: "Transferencias",
    total_redeem: "Total en BLUE",
    total_redeem_USDT: "Total en USDT",
    total_plus_block: "Disponíble + bloqueado",
    token_supply_equivalence: "Suministro de tokens equivalente en",
    transaction_failed_step:
      "la transacción falló en el paso {step}, si tiene alguna pregunta, comuníquese con el soporte al support@bluetoken.io",
    transfer_blu_stx:
      "Envíe sus BLUE tokens a <span class='custom_highlight'>StratumX.io</span>. Use para hacer trading com otras criptos.",
    transfer_blu_stratum:
      "Envíe sus BLUE tokens a SmartWallet. Use para vender BLUE, pagar cuentas, y otros servicios.",
    transfer_blu_stratum_withdraw_sw:
      "Envíe sus tokens BLUE a Stratum Advanced Wallet y disfrute de muchos beneficios.",
    tag_text:
      "El TAG es un identificador único para reconocerlo y puesto a disposición por el socio de retiro. El TAG se encuentra en la página de depósito de la cartera del socio.",
    table_failed_1: "* Pedidos incompletos",
    table_failed_2:
      "* Todos los pedidos incompletos se cancelarán automáticamente.",
    thank_you: "Gracias",
    temporarily_unavailable: "Temporariamente indisponible.",
    tether_info:
      "Envíe a través de la red Tron (TRC20) o use su saldo disponible.",
    token_type: "Tipo de token",
    today: "Hoy",
    bep20: "BEP20 (Binance Smart Chain)",
    decentralized_ex: "Decentralized Exchanges (DEX)",
    metaverse: "Metaverso",
    lending: "Préstamos",
    payments: "Pagos",
    native: "Nativo",
    erc20: "ERC20 (Ethereum)",
    todays_market: "Mercado de hoy",
    token_supply: "Suministro de tokens",
    tks_your_payment: "Gracias por su pago.",
    wait_create_tokens: "Espere unos minutos mientras creamos su(s) token(s).",

    //tickers
    BLU: "BLUE",
    BTC: "Bitcoin",
    ETH: "Ethereum",
    TUSD: "TrueUSD",

    //transaction tables
    createdAt: "Creada en",
    updatedAt: "Actualizada en",
    status: "Status",
    done: "Completo",
    pre_done: "Completo",
    failed: "Fallado",
    new: "Nuevo",
    processing: "Processando",
    txid: "TX ID",
    start_date: "Fecha de Inicio",
    end_date: "Fecha Final",

    //u
    use_all: "Usar todo",
    userid: "ID de Usuario",
    user: "Usuario",
    use: "Usar",
    user_id_inportant:
      "Asegúrese de ingresar el ID de usuario correcto para asegurarse de que la cantidad se envíe a la cuenta deseada",

    //v
    value: "Valor",
    view_all_transactions: "Ver todas las transacciones",
    view_reward_bonus_schedule: "Ver programa de recompensas y bonificaciones",
    view_status: "Ver status",
    voting_info_1:
      "Es hora de votar por 2 criptomonedas para agregar (o mantener) como parte de BLUE para el primer trimestre (T1) del 2023.",
    voting_info_2:
      "Últimamente, los reguladores del gobierno están detrás de empresas de criptomonedas que ofrecen beneficios en arbitraje y actividades similares. El cumplimiento de los reguladores daría lugar a comprometer la privacidad de nuestros usuarios. Como saben, aquí en Stratum, nuestra privacidad y seguridad del usuario siempre ha sido nuestra principal prioridad. Entonces decidimos eliminar esas actividades y basar BLUE en el valor de 14 criptomonedas en lugar de 12.",
    voting_info_3:
      "Simplemente haga clic en el botón de abajo y seleccione 2 criptomonedas. La votación no es obligatoria, pero recomendada. Creemos que cualquiera de las opciones dadas será una adición prometedora a la cesta BLUE. Contaremos los votos de acuerdo con el número de BLUE en su cuenta (cada BLUE completo en su cuenta le da 1 voto). La votación estará disponible hasta el 30 de Diciembre 23:59h (UTC -3).",
    voting_info_4:
      "Agregaremos más detalles sobre este cambio en un papel blanco actualizado en nuestro sitio web, como la frecuencia de votación y su futura implementación usando blockchain.",
    vote_bellow: "Vote abajo",
    vote_success: "Votó con éxito, gracias!",
    voting_survey: "Encuesta de votación",
    verify_step: "Verifique su redención",
    view_other_currencies: "Ver otras monedas",
    verify_your_withdraw: "Verifique su retiro",

    //w
    waiting: `Procesando`,
    welcome: "Bienvenido(a)",
    with: "con",
    withdraw: "Retiro",
    withdraws: "Retiros",
    withdraw_amount: "Monto de Retiro",
    withdraw_transfer: "Retirar",
    was_referred:
      "Pídale a su amigo su código de referencia para ganar recompensas, o déjelo en blanco para donar a Bitgive y B4H.",
    waiting_for_aprove: "En Orden",
    waiting_aprove_info:
      "Fondos disponibles solo 60 días después de cada compra.",
    w: "S",
    withdraw_sub: `Retiro es una operación que le permite transferir BLUE a una dirección de BLUE válida y compatible.`,
    withdraw_sub_usdt: `Retiro es una operación que le permite enviar USDT a un y dirección de billetera USDT compatible.`,
    withdraw_network_fee: "Para retiros existe la tarifa de red de 0.0005 btc",
    we_accet: "Nosotros aceptamos",
    why_change: "Por qué el cambio",
    white_paper: "Papel Blanco",
    withdrawal_steps: "Pasos de retirada",
    withdrawal: "Retiro",
    withdrawing: "Retiro",

    //y
    you_will_receive: "Usted recibirá",
    your_email_shortly: "Su correo electrónico deberá llegar en breve",
    you_want_start_new_purchase:
      "Está cancelando una orden de depósito, si desea realizar una nueva, inicie el flujo de compra nuevamente.",
    you_must_accpet_terms:
      "Debe aceptar nuestros términos y condiciones para continuar. Si tiene alguna pregunta, comuníquese con support@bluetoken.io.",
    you_must_accpet_privacy:
      "Debe aceptar nuestros política de privacidad para continuar. Si tiene alguna pregunta, comuníquese con support@bluetoken.io.",
    yes: "Sí",
    no: "No",

    //newBuyTexts
    beforeSendUnderTitle: `Seleccione la cantidad de BLUE que desea comprar. El pago debe hacerse con criptomoneda.`,
    blockMsgP: `Creación de nuevos tokens esta temporariamente indisponible.`,
    amount_in: "Monto en",
    estimated_amount_in: "Monto estimado en",
    important: "importante",
    below_button_1: `- La cantidad de BLUE para acreditar depende de la cantidad de cripto que recibimos. Tenga en cuenta las tarifas que su cartera podría cobrarle por la transferencia. Dichos cargos disminuirán la cantidad de cripto recibido, disminuyendo así también la cantidad de tokens.`,
    below_button_2: `- Si la cantidad de BTC que recibimos está por debajo del mínimo requerido (0.0208 BTC), su BTC se agregará a un saldo temporal, que puede usar en un nuevo pedido. `,
    understand_and_agree: `Entiendo que cualquier monto por encima del mínimo enviado a nuestra dirección de pago se convertirá a BLUE automáticamente.`,
    i_understand: "Entiendo",
    understand_and_agree_button: `Entiendo y estoy de acuerdo`,
    understand_and_agree_warning: `El tiempo de compra es entre las 9 a.m. y las 5 p.m. (GMT-3), de lunes a viernes. Las transacciones realizadas fuera de ese período se procesarán al día siguiente.`,
    waiting_deposit: `En espera de depósito`,
    waiting_deposit_otc: `Esperando confirmación de OTC`,
    transaction_details: `Detalles de la transacción`,
    transaction_failed_1: `transacción falló en el paso `,
    transaction_failed_2: `Si tiene alguna pregunta, comuníquese con el soporte técnico en support@bluetoken.io`,
    temporary_balance: `Saldo temporal`,
    temporary_balance_substracted: `Este saldo temporal se resta del monto total a enviar.`,
    to_send: `para Enviar`,
    to_receive: `para Recibir`,
    received: `Recibido`,
    expected: `anticipado`,
    expected_amount_in: `Cantidad estimada en`,
    estimated_blu: `BLUE estimado`,
    estimated: `estimado`,
    waiting_deposit_undertext: `El monto de BLUE se confirmará con la confirmación del pago en el blockchain.`,
    processing_order: `Procesando orden`,
    confirmed_amoutn: `monto confirmado`,
    follow_transaction_text: `Seguir la Transacción`,
    check_transaction_status: `Revisar el status de la operación`,
    new_operation: `Operación Nueva`,
    order_created: `Orden Creada`,
    confirmed_on_blockchain: `Confirmada en el blockchain`,
    order_completed: `Orden Completa`,
    order_completed_info:
      "Se está creando su BLUE, recibirá un certificado por correo electrónico cuando se complete el proceso.",
    order_completed_info_title: "Completo",
    temporary_balance_warning: `Tenga en cuenta que tiene un saldo temporal de transacciones anteriores que se agregará a su transferencia.`,
    send_btc_to_address: `Envie su {coin} a esta direccion para recibir sus BLUE`,
    purchase_confirmation: `Confirmación de Compra`,
    min: `min`,
    btc_sent: "BTC Confirmado",
    blu_confirmed: `BLUE Confirmado`,
    minimum_amount_required: `El monto debe ser sobre el mínimo.`,
    check_open_orders: `verificar orden abierta`,
    make_new_order: `realizar nueva orden`,
    if_no_order: `Si no se muestra ningún pedido durante un período prolongado, asegúrese de haber realizado un pedido. Si es necesario, haga uno nuevo.`,
    confirmed: "Confirmado",
    waiting: "Esperando",
    action_blocked_purchase: `Nuestro sistema se encuentra actualmente en mantenimiento, por favor intente su compra más adelante.`,
    bktc_text: "Bank to Crypto le permite comprar Bitcoin rápidamente.",
    bktc_text2:
      "Para continuar con su transacción, pague con Fiat a continuación",
    bktc_only_brazil: `Tenga en cuenta que este método de pago solo debe ser utilizado por clientes brasileños.`,
    info_link_stratum_wallet: "Acceda a su SmartWallet para comprar cripto.",
    select_coin_payment: "Seleccione un Método de Pago",

    //other long phrases
    your_id_is: `Su identificación es el código de identificación de 6 dígitos enviado a su correo electrónico al registrarse.`,
    amount_too_small:
      "La cantidad es muy pequeña. La compra mínima es de 100TUSD.",
    aware_token_redeem:
      "Sé que los tokens no se pueden transferir hasta 60 días después de la compra.",
    click_here_phases:
      "Haga clic aquí para obtener más detalles sobre cada fase.",
    create_new_email_recommendation: `Le recomendamos que cree un nuevo correo electrónico para cada plataforma. <span class="text_highlight">Este correo electrónico se utilizará para recibir su información de inicio de sesión y otra comunicación interna.</span>`,
    current_presale_ends: "Actual Pre-Venta Fase 3 finaliza Abril 6",
    did_someone_referred: "¿Alguien te refirió? (Opcional)",
    i_read_and_accept:
      'He leído y acepto los <a href="/terms" class="dis_inb main_white_fill main_white_fill_hover underline" target="_blank">Términos & Condiciones</a> y <a href="/privacy" class="dis_inb main_white_fill main_white_fill_hover underline" target="_blank">Política de Privacidad</a>.',
    // i_read_and_accept_policy:
    //   'He leído y acepto los <a href="/privacy" class="dis_inb main_white_fill main_white_fill_hover underline" target="_blank">Política de Privacidad</a>.',
    i_read: "He leído y acepto los Términos y Condiciones.",
    i_read_privacy: "He leído y acepto los Política de Privacidad.",
    not_usa_citizen: `Declaro que no soy ciudadano o residente de los Estados Unidos de América.`,
    not_china_citizen: `Declaro que no soy ciudadano ni residente de Hong Kong.`,
    scan_qr_code_or_copy_address: "Escanee el código QR o copie la dirección.",
    warning_60days:
      "Redenciones y retiros no están disponibles hasta 60 días después de la compra. No envíe el pago si no tiene la intención de comprar tokens.",

    //portfolio
    portfolio_intro: `Nuestra cripto-cesta está conformada por un grupo seleccionado de criptomonedas que tienen una confianza de mercado verificable o un gran potencial de crecimiento.`,
    text_LUNA:
      "Terra es un protocolo blockchain que utiliza stablecoins indexados en fiat para impulsar sistemas de pagos globales con precios estables.",
    text_BTC:
      "Criptomoneda con la mayor capitalización de mercado. Utilizado para pagos y como reserva de valor.",
    text_ETH:
      "Primera plataforma de criptomonedas para crear contratos inteligentes y aplicaciones descentralizadas.",
    text_XRP:
      "XRP es utilizado por bancos y empresas para asegurar liquidez en transferencias.",
    text_LTC:
      "Conocido como la plata al oro de Bitcoin. En los primeros días de la criptomonedas, Litecoin se creó para ser una versión más rápida y menos costosa de Bitcoin.",
    text_BCH:
      "Bitcoin Cash se creó a partir de un fork de Bitcoin (división de monedas). Es una versión modificada de Bitcoin que busca transacciones más rápidas y menos costosas.",
    text_EOS:
      "Plataforma para construir aplicaciones descentralizadas, sin tarifas de transacción.",
    text_XLM:
      "Lumens se utilizan para remesas, permitiendo liquidaciones entre diferentes monedas.",
    text_ADA:
      "Proyecto destinado a desarrollar la plataforma de contratos inteligentes más avanzada. Su equipo consiste en un gran colectivo global de expertos, incluido Charles Hoskinson, cofundador de Ethereum.",
    text_BNB:
      "Token digital creado por la plataforma de negociación Binance, que brinda varios beneficios a sus operadores.",
    text_TRX:
      "Plataforma descentralizada para compartir y monetizar el entretenimiento digital.",
    text_ZCR:
      "Criptomoneda creada para pagos simplificados. Los servicios que usan Zcore incluyen un sistema de mensajería móvil y masternodes.",
    text_NXS:
      "La arquitectura avanzada de blockchain de Nexus proporciona la mayor escalabilidad y seguridad. Nexus también tiene como objetivo descentralizar Internet al proporcionar acceso a través de satélites en el espacio.",
    text_IOTA:
      "El proyecto IOTA tiene como objetivo crear un ecosistema financiero seguro y descentralizado para Internet de las cosas (IoT).",
    text_XMR:
      "Monero sobresale en privacidad y no-rastreabilidad. Las transacciones no pueden vincularse a un usuario particular o identidad del mundo real.",
    text_OTC:
      "Criptos actualmente incluyen SafeInsure (SINS), Zcore (ZCR), SmartCash (SMART), DashGreen (DASHG), BitTorrent (BTT), Wink (WIN) y Bitcoin (BTC).",
    text_DASH:
      "Una de las criptomonedas más conocidas con una vasta red de usuarios en crecimiento. Presente desde los primeros días de las criptomonedas, Dash se enfoca en pagos rápidos y seguros.",
    text_LINK:
      "Token de Ethereum que alimenta la red oracle descentralizada Chainlink, permitiendo que los contratos inteligentes se conecten de forma segura a fuentes de datos externas, API y sistemas de pago.",
    text_LEND:
      "Token digital utilizado en Aave, una de las plataformas DeFi de préstamos de más rápido crecimiento, que brinda grandes beneficios a sus usuarios.",
    text_DOT:
      "Polkadot tiene como objetivo facilitar una web descentralizada totalmente funcional y fácil de usar (Web 3.0), permitiendo transferencias entre blockchains de cualquier tipo de datos o activos.",
    text_UNI:
      "Token de gobernanza de Uniswap, una de las plataformas comerciales descentralizadas más grandes alojadas en Ethereum, que facilita el comercio de tokens de finanzas descentralizadas (DeFi).",
    text_FIL:
      "Filecoin es un sistema de almacenamiento descentralizado. A diferencia de las empresas de almacenamiento en la nube como Amazon o Cloudflare, Filecoin aprovecha su naturaleza descentralizada para proteger la integridad de los datos.",
    text_THETA:
      "Theta es la criptomoneda nativa de Theta Network, un blockchain para mejorar la calidad y la capacidad de entrega del contenido de streaming de video.",
    text_MANA:
      "Token digital utilizado en Decentraland, una plataforma de realidad virtual, que permite a los usuarios comprar, personalizar y vender terrenos virtuales como NFTs.",
    text_CAKE:
      "Token de gobernanza de PancakeSwap, la plataforma de trading descentralizada (DEX) de más rápido crecimiento alojada en Binance Smart Chain.",
    text_MATIC:
      "Token de gobernanza de Polygon, una red de segunda capa para el desarrollo de infraestructura y escalamiento de Ethereum. Con Polygon, Ethereum se convierte en un sistema multi-chain, lo que facilita la interoperabilidad del blockchain, con transacciones más rápidas a un costo menor.",
    text_SOL:
      "Token nativo de la red Solana, un blockchain de rápido crecimiento en el espacio DeFi, con excelente velocidad y escalabilidad, capaz de alcanzar hasta 65,000 transacciones por segundo.",
    text_CRV:
      "Token nativo de Curve Finance, el intercambio descentralizado (DEX) con el mayor volumen actual en DeFi. Curve Finance es único debido a su optimización para intercambios con bajo deslizamiento entre stablecoins o activos similares que se vinculan al mismo valor.",
    text_AVAX:
      "Token nativo de Avalanche, un blockchain de contratos inteligentes prometedor en DeFi y el espacio NFT.",
    text_MBOX:
      'Token de gobernanza de en Mobox, una aplicación de juegos descentralizada "play-to-earn", que permite a los usuarios intercambiar NFT y ser recompensados ​​por su participación.',
    text_USDT: "Stablecoin al par con el Dólar Americano.",
    text_TUSD: "Stablecoin al par con el Dólar Americano.",

    //charity text
    bitgive_info:
      "Uso de la tecnología bitcoin y blockchain para mejorar la salud pública y el medio ambiente en todo el mundo.",
    b4h_info:
      "Apoya a las organizaciones que usan la tecnología blockchain para traer un cambio positivo a la humanidad.",

    //tooltip
    tooltip_text_charity:
      "Hasta el 50% de nuestras tarifas de venta se donan a Bitgive y Blockchain for Humanity.",
    tooltip_purchase_referral:
      "Puede llenar este campo si alguien le ayudó con la compra.",
    tooltip_internal_withdraw: "Este es el ID de usuario del destinatario.",

    //redeem
    current_balance: `Saldo actual`,
    unlocked_balance: `Saldo desbloqueado`,
    total_without_fees: `Total sin tarifas`,
    total_to_receive: `Total a Recibir`,

    min_length: `Longitud mínima es`,
    characters: `caracteres`,
    contact_intro: `Si tiene alguna pregunta o problema que necesita resolver, contáctenos en el siguiente formulario`,
    email_to_registered: `El email se enviará a su email registrado en la plataforma.`,
    subject: `asunto`,
    message: `mensaje`,
    form_sent: `Mensaje enviado com éxito`,
    form_error: `Se produjo un error al enviar su mensaje. Vuelva a intentarlo.`,
    insufficient_funds: `Fondos insuficientes`,

    //modal voting coins
    coin_voting_enj:
      'Token digital utilizado en la red ENJIN, una plataforma de social gaming, que permite a los usuarios monetizar elementos del juego, como NFTs. <a href="https://enjin.io/" target="_blank">Aprenda más</a>',
    coin_voting_mana:
      'Token digital utilizado en Decentraland, una plataforma de realidad virtual, que permite a los usuarios comprar, personalizar y vender terrenos virtuales como NFTs. <a href="https://decentraland.org/" target="_blank">Aprenda más</a>',
    coin_voting_bat:
      'Token digital utilizado para recompensar a los usuarios y editores en el creciente navegador "Brave". Los editores y creadores obtienen ingresos por publicidad, así como propinas, mientras que los usuarios mantienen la privacidad a medida que obtienen BAT por ver anuncios. <a href="https://basicattentiontoken.org/" target="_blank">Aprenda más</a>',
    coin_voting_dash:
      'Una de las criptomonedas más conocidas con una vasta red de usuarios en crecimiento. Dash se enfoca en pagos rápidos y privados, ofreciendo "PrivateSend" para activar transacciones imposibles de rastrear. <a href="https://www.dash.org/" target="_blank">Aprenda más</a>',
    coin_voting_mkr:
      'Token digital creado por MakerDAO, una de las mayores plataformas DeFi , que proporciona préstamos respaldados por Ethereum. <a href="https://makerdao.com/en/" target="_blank">Aprenda más</a>',
    coin_voting_xtz:
      'Criptomoneda nativa del blockchain Tezos, que se enfoca en integrar la tecnología de Smart Contracts con productos financieros.Últimamente, varios proyectos de NFT, como los Cleveland Cavaliers y McLaren, están utilizando Tezos para sus colecciones. <a href="https://tezos.com/" target="_blank">Aprenda más</a>',
    coin_voting_lend:
      'Token digital utilizado en Aave, una de las plataformas de préstamos DeFi de más rápido crecimiento, que brinda grandes beneficios a los usuarios de AAVE. <a href="https://aave.com/" target="_blank">Aprenda más</a>',
    coin_voting_atom:
      'Ecosistema de blockchains de rápido crecimiento que pueden escalar e interoperar entre sí, competidor de Polkadot (DOT), Ethereum (ETH) y otras importantes criptomonedas de contratos inteligentes. <a href="https://cosmos.network/" target="_blank">Aprenda más</a>',
    coin_voting_band:
      'Plataforma oracle de cross-chain data que agrega y conecta datos y API del mundo real a Smart Contracts. <a href="https://bandprotocol.com/" target="_blank">Aprenda más</a>',
    coin_voting_aave:
      'Token digital utilizado en AAVE, una de las mayores plataformas de préstamos DeFi. AAVE se actualizó recientemente a la versión 3.0, proporcionando préstamos "cross-chain" y un nuevos mecanismos para mejorar la experiencia del usuario, la gestión de riesgos y la eficiencia del capital. <a href="https://aave.com/" target="blank_">Aprenda más</a>.',
    coin_voting_uni:
      'Una de las plataformas de comercio descentralizado más conocidas, que facilita el comercio automatizado de tokens de finanzas descentralizadas (DeFi). <a href="https://uniswap.org/" target="blank_">Aprenda más</a>.',
    coin_voting_fil:
      'Filecoin es un sistema de almacenamiento descentralizado. A diferencia de las empresas de almacenamiento en la nube como Amazon o Cloudflare, Filecoin aprovecha su naturaleza descentralizada para proteger la integridad de los datos. <a href="https://filecoin.io/" target="blank_">Aprenda más</a>.',
    coin_voting_cake:
      'Token de gobernanza de PancakeSwap, la plataforma de comercio descentralizada de más rápido crecimiento alojada en Binance Smart Chain. <a href="https://pancakeswap.finance/" target="blank_">Aprenda más</a>.',
    coin_voting_matic: `Token de gobernanza de Polygon, una red de segunda capa para el desarrollo de infraestructura y escalamiento de Ethereum. Con Polygon, Ethereum se convierte en un sistema multi-chain, lo que facilita la interoperabilidad del blockchain, con transacciones más rápidas a un costo menor. <a href="https://polygon.technology/" target="blank_">Aprenda más</a>.`,
    coin_voting_sand: `Token de gobernanza de The Sandbox, un mundo de realidad virtual donde las personas pueden crear, compartir y vender contenido como NFT, como juegos y experiencias únicas. <a href="https://sandbox.game/" target="blank_">Aprenda más</a>.`,
    coin_voting_axs: `Token de gobernanza de Axie Infinity, el juego de realidad virtual "jugar para lucrar" de más rápido crecimiento que utiliza NFT. Más de 1 millón de jugadores activos diarios "luchan" en Axie Infinity por la oportunidad de ganar recompensas en cripto. <a href="https://axieinfinity.com/" target="blank_">Aprenda más</a>.`,
    coin_voting_mbox: `Token de gobernanza en Mobox, una aplicación de juegos descentralizada de juego para ganar, que permite a los usuarios intercambiar NFT y ser recompensados ​​por su participación. <a href="https://www.mobox.io/#/" target="blank_">Aprenda más</a>.`,
    coin_voting_xmr: `Criptomoneda enfocada en la privacidad. Monero fue diseñado para evitar la censura, y sus transacciones son totalmente imposibles de rastrear. <a href="https://monero.org" target="blank_">Aprenda más</a>.`,
    coin_voting_egld: `Elrond es un blockchain diseñada para un alto rendimiento y una velocidad de ejecución rápida en comparación con otras plataformas de contratos inteligentes. Para aumentar la adopción, el proyecto apoya a los desarrolladores que construyen en la plataforma, lo que les permite ganar el 30 % de las tarifas de los contratos inteligentes como regalías. <a href="https://elrond.com/" target="blank_">Aprenda más</a>.`,
    coin_voting_etc: `Ethereum Classic es el Ethereum original, que todavía funciona con Prueba de trabajo (mineros). ETC se utiliza para pagar la ejecución de transacciones y funciones de contratos inteligentes. <a href="https://ethereumclassic.org/" target="blank_">Aprenda más</a>.`,
    coin_voting_ton: `Toncoin (TON) es una cadena de bloques de capa 1 descentralizada desarrollada en 2018 por la plataforma de mensajería encriptada Telegram. Luego, el proyecto fue abandonado, asumido por la Fundación TON y renombrado de "Telegram Open Network" a "The Open Network". <a href="https://ton.org/" target="blank_">Aprenda más</a>.`,
    coin_voting_xlm: `Stellar es una red de pagos de código abierto que sirve como una cadena de bloques intermediaria distribuida para los sistemas financieros globales y hace circular un activo nativo, Stellar Lumens (XLM). <a href="https://stellar.org/" target="blank_">Aprenda más</a>.`,

    modalNetwork: {
      title: "Anuncios",
      text_one: `Nos complace informarle que recientemente agregamos nuevos elementos:`,
      title_two: "Blue Club",
      text_two: `Se otorga un NFT de membresía Blue Club a los usuarios que compran 20 tokens BLUE o más. Los miembros de Blue Club disfrutan de los siguientes beneficios:`,
      text_two_t: `Puede seguir el progreso de su calificación en su Tablero. ¡Esperamos darle la bienvenida a Blue Club!`,
      title_three: "Tether Wallets",
      text_three:
        "Ahora puede depositar y retirar Tether (USDT), lo que le brinda más flexibilidad de inversión. Decide si es un buen momento para comprar y mantener Blue Tokens, o mantener Tether en tu billetera para cuando sea el momento adecuado."
    },

    modalBscInfo: {
      title: "Anuncios",
      text_one: `Como se informó anteriormente en nuestros informes trimestrales, BLUE cambiará de blockchain. El token BLUE dejará el blockchain NEM para alojarse en el blockchain Binance Smart Chain (BSC).`,

      text_two: `La mudanza está programada para el jueves 11 de noviembre de 2021 a las 9:00h (UTC-3). La plataforma no estará disponible durante esta transición, que se espera sea de 4 días. Esperamos tener la plataforma en funcionamiento nuevamente el lunes 15 de noviembre. Durante este tiempo, todas las operaciones no estarán disponibles, así que planifique en consecuencia.`,

      title_two:
        "El precio del token y el saldo de los usuarios no se verán afectados.",
      text_three:
        "Los usuarios tendrán la misma cantidad de tokens que tenían antes de la mudanza. El precio del token continuará rastreando las 14 criptomonedas en nuestra canasta durante este período.",
      title_four:
        "Estamos muy entusiasmados con la mudanza. BSC permitirá una integración más fácil de BLUE con terceros que deseen trabajar con el token. BSC está creciendo rápidamente, siendo actualmente el segundo blockchain más grande utilizado en aplicaciones DeFi. Debido a sus tarifas bajas, los desarrolladores y usuarios consideran BSC como una alternativa más barata a Ethereum. Además, BSC se creó para alojar proyectos de Ethereum, por lo que a los desarrolladores les resulta  fácil alojar sus proyectos en Ethereum y BSC.",
      title_five:
        "Como prometimos, trabajamos constantemente para crecer BLUE. Este movimiento es un paso muy importante hacia nuestra expansión. Agradecemos a todos nuestros usuarios que continúan apoyando el proyecto."
    },

    modalBluePool: {
      title: "Announcements",
      text_one: `Hemos actualizado nuestros términos y condiciones.`,
      title_one: "Tarifa de compra",
      text_two: `Bajamos la tarifa de compra del token BLUE, del 6% al 2% (anual). Esto reducirá los costos para las personas que deseen comprar tokens BLUE por primera vez, y aquellos que suelen hacer aportes mensuales.`,
      title_two: "Tarifa de custodia",
      text_three:
        "Aumentamos nuestra comisión de custodia del 2,5 % al 6 %. Esto nos permitirá brindarle mejores herramientas, servicio y seguridad, además de la creación de un nuevo sistema de recompensas.",
      title_four: "Nuevo sistema de recompensas: Blue Pool",
      text_four:
        "Presentamos un nuevo sistema de recompensas: Blue Pool. Todos los usuarios ahora pueden participar en un grupo de recompensas mensuales. Las recompensas se pagan a los usuarios que recomiendan a sus amigos que compren tokens BLUE. El primer “pool” se fijó en 4.20 BLUE (aproximadamente $1,800 dólares). ¡Gane su parte!"
    },

    modalClainBlueClub: {
      title: "Obtenga su Blue Club NFT",
      text2: "¡Felicidades! Ahora pertenece al selecto club VIP de Blue Token.",
      text3:
        "Ahora debe reclamar su NFT, que le dará acceso a varios beneficios de membresía.",
      text4: "Ingrese su dirección de Solana:",
      text5: "Use una billetera Exodus o Phantom para almacenar su NFT.",
      text6:
        "Si tiene alguna pregunta, comuníquese con nuestro equipo de soporte.",

      text7: "¡Bienvenidos a Blue Club!",
      text8: "Se está creando su NFT. Lo recibirás en 2 días hábiles.",
      text9:
        "Recibirás un correo electrónico de bienvenida. Por favor, asegúrese de que no esté en su correo spam, ya que lo mantendremos informado sobre eventos y servicios en los que recibirá un trato VIP.",
      text10: "OK, GENIAL!"
    },

    modalDhbtInfo: {
      title: "Anuncios",
      text_one: `Hemos actualizado nuestros términos y condiciones.`,

      text_two: `Como se anunció anteriormente, Blue Token ahora es un producto de una empresa recién formada, Digital Horizon Blockchain Technology, registrada en el país de El Salvador.`,

      title_two:
        "La medida se debió a varios beneficios otorgados por El Salvador a las cripto empresas. El Salvador es el único país del mundo que ha aceptado Bitcoin como moneda de curso legal. Su gobierno está incentivando a las empresas de criptomonedas a invertir y prosperar, preparando la base para el crecimiento futuro en innovación tecnológica e infraestructura.",
      text_three:
        "Estamos muy entusiasmados con el cambio y estamos listos para aprovechar los beneficios de El Salvador para llevar a Blue Token al siguiente nivel.",
      title_four:
        "Si tiene alguna pregunta, envíenos un e-mail a support@bluetoken.io.",
      title_one:
        "Blue es un producto de Digital Horizon, con sede en El Salvador",
      title_five: "Pagos y tarifas de redenciones",
      text_four:
        "A partir del 2 de febrero, todos las redenciones se pagarán solo en USDT (Tether), junto con cambios en las tarifas de redención:",
      text_six: `Tarifa de redención: 1% del valor de redención <br/>Tarifa mínima de redención: 50 USDT`,
      text_seven:
        "El tiempo de pago seguirá siendo de 3 días hábiles. Los usuarios tendrán la opción de pago el mismo día por una tarifa."
    },

    modalBuyBluePix: {
      buy_blue: "Comprar BLUE",
      connecting_swapix: "Conectándose a SWAPiX",
      only_accepts: "Blue Token solo acepta pagos en criptomonedas.",
      pix_purcase_processed:
        "Afortunadamente, las compras de Pix son procesadas por nuestro socio de confianza SWAPiX.",
      swapix_terms: `He leído los <a class=p5_l href=https://usdt.smartpay.com.vc/static/media/terms_jun.f681a88b.pdf target=blank  style="margin-right:5px">términos y condiciones</a> de SWAPiX.`,
      btn_next: "Siguiente",
      welcome: "Bienvenido a",
      payment_being_processed: "Su información de pago está siendo procesada.",
      wait: "Espera unos segundos mientras hacemos nuestra magia...",
      payment: "Pago",
      convert_price: "Tipo de cambio",
      completed_buy:
        "Su compra ha sido completada. Si su saldo no está actualizado, actualice la página."
    },

    modalWarnUser: {
      title: "Retirar: Importante",
      warn1:
        "Asegúrese de que la cartera receptora acepte tokens BLUE. No todas las carteras BSC son compatibles con BLUE",
      warn2:
        "Blue Token no asume responsabilidad por operaciones que ocurran en plataformas de terceros.",
      warn3:
        "Todas las transacciones que se originan fuera de nuestra plataforma incurren en una tarifa del 6%.",
      warn4:
        "Retiros son irreversibles. Asegúrese de enviar sus tokens a una parte confiable.",
      i_understand: "Entiendo"
    },

    modalBlueClub: {
      title: "Beneficios de membresía",
      subTitle:
        "Se otorga un NFT de membresía de Blue Club a los usuarios que compran 20 tokens o más.",
      text1: `<div style="display:flex"><a href="https://solscan.io/token/AP9rP81KJzPCQFmE4fK9Ue8NWRaXZ5QbqQJn6PKhQP17" target="_blank" style="color: #cb36ee; text-decoration:underline; margin-right:5px">Blue Club NFT</a> (Token No-fungible).</div>`,
      text2:
        "Acceso prioritario/VIP a todos nuestros eventos, incluidos regalos y souvenirs.",
      text3: "Servicios exclusivos de consultoría.",
      text4:
        "Recompensas de nuestros socios (airdrops, obsequios, promociones).",
      text5: "Invitación a eventos exclusivos de networking."
    },

    settings: {
      title: "Configuraciones de Cuenta",
      profile: "Perfil",
      security: "Seguridad",
      notifications: "Notificaciones",

      updateInfoProfile: "Actualice la información básica de su perfil.",
      updateInfoSecurity: "Actualice su información básica de seguridad.",
      updateInfoNotifications:
        "Deshabilite o habilite sus notificaciones por correo electrónico.",

      currently: "Corrientemente",
      profileStatus: "Estado del perfil",

      updateProfile:
        "Haga clic en Guardar para actualizar la información de su perfil.",
      updateSecurity:
        "Haga clic en Guardar para actualizar su información de seguridad.",
      updateNotification:
        "Haga clic en Guardar para actualizar la configuración de sus notificaciones.",

      toggleEmail: "Alternar sus notificaciones de correo electrónico",

      popupSure: "Esta seguro(a)?",
      popupConfirm: "Confirme su cambio de contraseña.",

      popupChangesApply:
        "Los cambios se aplicarán cuando vuelva a iniciar sesión."
    }
  }
};



// WEBPACK FOOTER //
// ./src/lang/es.js